import { textToKebab} from './toKebabCase'

const topicUrlGenerator = (type: string, title: string, id: string, category?: string | null, postId?: string) => {
    const typePath = `/${type}`
    const categoryPath = category ? `/${category}` : ''
    const titlePath = `/${textToKebab(title)}`
    const idPath = `-${id}`
    const postIdPath = postId ? `?postid=${postId}#post${postId}` : ''
    return (typePath + categoryPath + titlePath + idPath + postIdPath).toLowerCase() as string
}

export default topicUrlGenerator